"use strict";

exports.__esModule = true;
exports.Button = void 0;

var React = _interopRequireWildcard(require("react"));

var _Button = require("./Button.styles");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/button/src/Button.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Button = React.forwardRef((props, ref) => {
  const {
    as = 'button',
    children: childrenProp,
    colorTheme = 'primary',
    endIcon,
    href,
    isActive,
    isDisabled,
    rel,
    size = 'medium',
    startIcon,
    target,
    tabIndex,
    type,
    variant = 'filled',
    ...other
  } = props;
  const ariaProps = as !== 'button' ? {
    'aria-disabled': !isDisabled ? undefined : isDisabled,
    href: as === 'a' && isDisabled ? undefined : href,
    rel: as === 'a' ? rel : undefined,
    role: 'button',
    tabIndex: isDisabled ? undefined : 0,
    target: as === 'a' ? target : undefined
  } : {
    disabled: isDisabled,
    tabIndex: isDisabled ? -1 : tabIndex,
    type: type ?? 'button'
  };
  let children = childrenProp;

  if (typeof children === 'string') {
    children = React.createElement(_Button.StyledButtonText, {
      className: "manifestui-button-text",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 81,
        columnNumber: 18
      }
    }, children);
  }

  return React.createElement(_Button.StyledButton, _extends({
    as: as,
    className: "manifestui-button",
    colorTheme: colorTheme,
    "data-active": isActive ? '' : null,
    "data-disabled": isDisabled ? '' : null,
    ref: ref,
    size: size,
    variant: variant
  }, ariaProps, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 7
    }
  }), startIcon && React.createElement(_Button.StyledButtonIcon, {
    className: "manifestui-button-endIcon",
    "data-placement": "start",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 11
    }
  }, startIcon), children, endIcon && React.createElement(_Button.StyledButtonIcon, {
    className: "manifestui-button-endIcon",
    "data-placement": "end",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 11
    }
  }, endIcon));
});
exports.Button = Button;
Button.displayName = 'Button';